import React from "react";
import SidebarBlog from "../../components/blogs/SidebarBlog";
import Footer from "../../components/layout/footer/Footer";
import Navbar from "../../components/layout/header/Navbar";
import Layout from "../../components/layout/Layout";
import PageHeader from "../../components/team/PageHeader";
import StudiesList from "../../components/features/StudiesList";

export default function CurrentStudies({ information }) {
  return (
    <Layout>
      <Navbar darkBg information={information} />
      <PageHeader
        HeaderTitle="Current Studies"
        PageTite="Current Studies"
        Parent="Current Studies"
      />
      <StudiesList />
      <Footer space information={information} />
    </Layout>
  );
}
